import React from 'react';
import './Switch.css';

/*
 * Switch — controlled toggle, the mock's `.switch`.
 *   checked   : boolean (controlled)
 *   onChange  : (nextChecked: boolean, event) => void
 *   disabled  : boolean
 *   label     : accessible name (aria-label) when there's no visible <label>
 * Renders a real <input type=checkbox> for keyboard + form semantics.
 */
export default function Switch({
  checked = false,
  onChange,
  disabled = false,
  label,
  id,
  className = '',
  ...rest
}) {
  const handle = (e) => { if (onChange) onChange(e.target.checked, e); };
  return (
    <span className={`switch${disabled ? ' switch--disabled' : ''}${className ? ' ' + className : ''}`}>
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={handle}
        disabled={disabled}
        aria-label={label}
        role="switch"
        aria-checked={checked}
        {...rest}
      />
      <span className="track" aria-hidden="true" />
    </span>
  );
}
